import { queryQuota } from '@/api/coupon-api.js'
import getTranslation from '@/i18n/getTranslation'

export default {
  data() {
    return {
      restriction: 0
    }
  },
  methods: {
    async getCanUseCoupon() {
      try {
        let {
          body: {
            result: { permission, restriction }
          }
        } = await queryQuota()
        this.restriction = restriction || 0
        if (permission == 0 || permission == 2) {
          this.$alert(
            getTranslation('您没有权限查询查看券额管理页面'),
            getTranslation('提示')
          )
            .then(() => {
              this.$router.push({ path: '/cost/coupon' })
            })
            .catch(() => {
              this.$router.push({ path: '/cost/coupon' })
            })
        }
      } catch (e) {
        console.log(e)
        this.$router.push({ path: '/cost/coupon' })
      }
    },
    getRestriction() {
      return this.restriction
    },
    noPermission() {
      this.$alert(
        getTranslation('您没有权限查询查看此页面'),
        getTranslation('提示')
      )
        .then(() => {
          this.$router.push({ path: '/cost/coupon' })
        })
        .catch(() => {
          this.$router.push({ path: '/cost/coupon' })
        })
    }
  },
  created() {
    this.getCanUseCoupon()
  }
}
